import { Outlet } from 'react-router-dom-v5-compat'

import { UpgradePathForCreate } from './components/UpgradePathForCreate'
import { useCurrentOrganization } from '../../contexts/AccountContext'

export function CreatePage(): JSX.Element | null {
  const currentOrganization = useCurrentOrganization()
  const isOneBufferOrg = currentOrganization?.isOneBufferOrganization
  const hasContentFeature =
    currentOrganization?.entitlements.includes('content')

  if (!currentOrganization?.id) {
    return null
  }

  if (!isOneBufferOrg || !hasContentFeature) {
    return <UpgradePathForCreate />
  }

  return <Outlet />
}
